module.exports = __webpack_public_path__ + "1ef602c3271f54f877f026f4a49796de.svg";